import {
  INSPECAO_MT_BT_TIPO_SERVICO_ID,
  INSPECAO_USUO_MUTUO_ID,
} from '../../../utils';
import moment from 'moment';
import {
  EMPTY_RESUMO,
  formatMedicaoPeriodLabel,
  getMedicaoPeriod,
  getMetric,
  getPreviousMedicaoPeriod,
  isMedicaoPeriod,
  isPreviousMedicaoPeriod,
  normalizeFilterForApi as normalizeFilterForApiLegacy,
  normalizeResumo as normalizeResumoLegacy,
  STATUS_FILTER_OPTIONS,
  STATUS_ORDER,
} from './constants';

export {
  EMPTY_RESUMO,
  formatMedicaoPeriodLabel,
  getMedicaoPeriod,
  getPreviousMedicaoPeriod,
  isMedicaoPeriod,
  isPreviousMedicaoPeriod,
  STATUS_FILTER_OPTIONS,
};

export const LENTE_IDS = {
  GERAL: 'GERAL',
  MT_BT: 'MT_BT',
  USO_MUTUO: 'USO_MUTUO',
};

export const LENTE_OPTIONS = [
  { id: LENTE_IDS.GERAL, label: 'Geral' },
  { id: LENTE_IDS.MT_BT, label: 'Inspeção MT/BT' },
  { id: LENTE_IDS.USO_MUTUO, label: 'Uso mútuo' },
];

export const META_DIARIA = {
  [LENTE_IDS.MT_BT]: 35,
  [LENTE_IDS.USO_MUTUO]: 120,
};

/** De-para lente → `tipoServicos`. O legado defaulta MT/BT; charts com lente precisam disto. */
export const TIPO_SERVICOS_BY_LENTE = {
  [LENTE_IDS.MT_BT]: [INSPECAO_MT_BT_TIPO_SERVICO_ID],
  [LENTE_IDS.USO_MUTUO]: [INSPECAO_USUO_MUTUO_ID],
  [LENTE_IDS.GERAL]: [INSPECAO_MT_BT_TIPO_SERVICO_ID, INSPECAO_USUO_MUTUO_ID],
};

export const getTipoServicosByLente = (lenteId) => [
  ...(TIPO_SERVICOS_BY_LENTE[lenteId] || TIPO_SERVICOS_BY_LENTE[LENTE_IDS.GERAL]),
];

export const TOP_N_DEFAULT = 8;

export const RANKING_RECORTE = {
  TOP: 'TOP',
  BOTTOM: 'BOTTOM',
  ABAIXO_META: 'ABAIXO_META',
  MAIS_CARGA: 'MAIS_CARGA',
};

export const RANKING_RECORTE_OPTIONS = [
  { id: RANKING_RECORTE.TOP, nome: 'Top 8', label: 'Top 8' },
  { id: RANKING_RECORTE.BOTTOM, nome: 'Bottom 8', label: 'Bottom 8' },
  { id: RANKING_RECORTE.ABAIXO_META, nome: 'Só abaixo da meta', label: 'Só abaixo da meta' },
  { id: RANKING_RECORTE.MAIS_CARGA, nome: 'Mais carga', label: 'Mais carga' },
];

export const RANKING_ORDER = {
  MEDIA_DESC: 'MEDIA_DESC',
  MEDIA_ASC: 'MEDIA_ASC',
  PENDENTES_DESC: 'PENDENTES_DESC',
};

export const RANKING_ORDER_OPTIONS = [
  { id: RANKING_ORDER.MEDIA_DESC, nome: 'Maior média', label: 'Maior média' },
  { id: RANKING_ORDER.MEDIA_ASC, nome: 'Menor média', label: 'Menor média' },
  { id: RANKING_ORDER.PENDENTES_DESC, nome: 'Mais pendentes', label: 'Mais pendentes' },
];

export const EQUIPE_CHIP = {
  TODOS: 'TODOS',
  ABAIXO_MT_BT: 'ABAIXO_MT_BT',
  ABAIXO_UM: 'ABAIXO_UM',
  COM_PENDENTES: 'COM_PENDENTES',
};

export const EQUIPE_CHIP_OPTIONS = [
  { id: EQUIPE_CHIP.TODOS, nome: 'Todos', label: 'Todos' },
  { id: EQUIPE_CHIP.ABAIXO_MT_BT, nome: 'Abaixo MT/BT', label: 'Abaixo MT/BT' },
  { id: EQUIPE_CHIP.ABAIXO_UM, nome: 'Abaixo uso mútuo', label: 'Abaixo uso mútuo' },
  { id: EQUIPE_CHIP.COM_PENDENTES, nome: 'Pendentes', label: 'Pendentes' },
];

export const EQUIPE_SORT = {
  NOME: 'NOME',
  MEDIA: 'MEDIA',
  PENDENTES: 'PENDENTES',
  NSIRS: 'NSIRS',
};

export const EQUIPE_SORT_OPTIONS = [
  { mode: EQUIPE_SORT.NOME, title: 'Nome A–Z' },
  { mode: EQUIPE_SORT.MEDIA, title: 'Média ↓' },
  { mode: EQUIPE_SORT.PENDENTES, title: 'Pendentes ↓' },
  { mode: EQUIPE_SORT.NSIRS, title: 'NSIRs ↓' },
];

export const EQUIPE_FACET = {
  PRODUTIVIDADE: 'PRODUTIVIDADE',
  CARGA_REGIAO: 'CARGA_REGIAO',
};

export const EQUIPE_FACET_OPTIONS = [
  { id: EQUIPE_FACET.PRODUTIVIDADE, label: 'Produtividade' },
  { id: EQUIPE_FACET.CARGA_REGIAO, label: 'Carga' },
];

export const GERENCIA_SIGLAS = ['LE', 'CE', 'PM', 'NT', 'TR', 'SU'];

export const LENTE_LOOKUP_CHIP = {
  TODOS: 'TODOS',
  ABAIXO: 'ABAIXO',
  PENDENTES: 'PENDENTES',
};

export const LENTE_LOOKUP_CHIP_OPTIONS = [
  { id: LENTE_LOOKUP_CHIP.TODOS, label: 'Todos' },
  { id: LENTE_LOOKUP_CHIP.ABAIXO, label: 'Abaixo da meta' },
  { id: LENTE_LOOKUP_CHIP.PENDENTES, label: 'Pendentes' },
];

export const getLenteLabel = (lenteId) => (
  LENTE_OPTIONS.find((item) => item.id === lenteId)?.label || lenteId
);

export const FERIADO_TIPOS_GLOBAIS = ['NACIONAL', 'ESTADUAL'];
export const FERIADO_UF_OPERACAO = 'MG';

export const getPeriodoPrefix = (inicio, fim) => {
  if (isMedicaoPeriod(inicio, fim)) return 'Período de medição';
  if (isPreviousMedicaoPeriod(inicio, fim)) return 'Período de medição anterior';
  return 'Período selecionado';
};
export const COMMAND_CENTER_PATH = '/v2/relatorio-digitacao';
export const LENTE_SESSION_KEY = 'eletropontes.relatorioDigitacaoAdmin.lenteId';

export const EMPTY_EQUIPE = {
  digitadoresCount: null,
  mediaDiaUtil: null,
  abaixoMetaCount: null,
  metaDiaria: null,
  lenteId: null,
  unidade: null,
  servicosPendentes: null,
  nsirsAguardando: null,
  nsirsEmDigitacao: null,
  digitadoresComPendencia: null,
  piorCarga: null,
  diasUteisGlobais: null,
  adere: null,
};

export const EMPTY_POR_LENTE = {
  lenteId: null,
  digitadoresCount: null,
  mediaDiaUtil: null,
  abaixoMetaCount: null,
  metaDiaria: null,
  nsirs: 0,
  servicosTotal: 0,
  servicosDigitados: 0,
  servicosPendentes: 0,
  digitadoresComPendencia: null,
  adere: null,
};

/** Adere de equipe/linha. Sem payload → null (não chama /me/adere em loop). */
export const normalizeAdere = (raw) => {
  if (!raw || typeof raw !== 'object') return null;
  if (
    raw.adereMonth == null
    && raw.servicosPendentes == null
    && raw.fechaNoPrazo == null
    && raw.emRiscoCount == null
  ) {
    return null;
  }
  return {
    adereMonth: raw.adereMonth || null,
    servicosPendentes: raw.servicosPendentes != null ? Number(raw.servicosPendentes) : null,
    fechaNoPrazo: raw.fechaNoPrazo ?? null,
    emRiscoCount: raw.emRiscoCount != null ? Number(raw.emRiscoCount) : null,
    digitadoresCount: raw.digitadoresCount != null ? Number(raw.digitadoresCount) : null,
  };
};

export const formatAdereMonthShort = (adereMonth) => {
  if (!adereMonth) return 'Adere';
  const raw = String(adereMonth);
  if (/^\d{4}-\d{2}$/.test(raw)) return `Adere ${raw.slice(5)}`;
  const [mm] = raw.split('/');
  return mm ? `Adere ${mm}` : `Adere ${raw}`;
};

/** Linha compacta da célula. Null se a API não mandou Adere. */
export const formatAdereLine = (adere) => {
  if (!adere) return null;
  const month = formatAdereMonthShort(adere.adereMonth);
  const pend = Number(adere.servicosPendentes) || 0;
  const risco = adere.fechaNoPrazo === false;
  if (pend <= 0 && !risco) return `${month} · nada pendente · no prazo`;
  if (risco) return `${month} · faltam ${pend} · risco`;
  return `${month} · faltam ${pend}`;
};

/** Mês calendário corrente para `GET …/adere/resumo?mes=` (`MM/YYYY`). */
export const getCurrentAdereMes = () => moment().format('MM/YYYY');

export const ADERE_LENTES = [LENTE_IDS.MT_BT, LENTE_IDS.USO_MUTUO];

const EMPTY_ADERE_RESUMO = {
  mes: null,
  lenteId: null,
  equipe: null,
  digitadores: [],
};

/** `GET /reports/digitacao/adere/resumo`. Falha / vazio → omitir UI. */
export const normalizeAdereResumoResponse = (data) => {
  if (!data || typeof data !== 'object') return { ...EMPTY_ADERE_RESUMO };
  const mes = data.mes || null;
  const equipe = data.equipe
    ? normalizeAdere({ ...data.equipe, adereMonth: data.equipe.adereMonth || mes })
    : null;
  const digitadores = (Array.isArray(data.digitadores) ? data.digitadores : [])
    .filter((item) => item?.digitadorId)
    .map((item) => ({
      digitadorId: item.digitadorId,
      adere: normalizeAdere({ ...item, adereMonth: item.adereMonth || mes }),
    }));
  return {
    mes,
    lenteId: data.lenteId || null,
    equipe,
    digitadores,
  };
};

const adereMapByDigitador = (resumo) => {
  const map = {};
  (resumo?.digitadores || []).forEach((item) => {
    if (item.digitadorId && item.adere) map[item.digitadorId] = item.adere;
  });
  return map;
};

/** Cruza `digitadores[]` do GET Adere nas colunas da tabela Geral. */
export const attachAdereToEquipeRows = (rows, adereByLente) => {
  const mtbtMap = adereMapByDigitador(adereByLente?.[LENTE_IDS.MT_BT]);
  const umMap = adereMapByDigitador(adereByLente?.[LENTE_IDS.USO_MUTUO]);
  return (rows || []).map((row) => ({
    ...row,
    mtbt: { ...row.mtbt, adere: mtbtMap[row.digitadorId] || null },
    usoMutuo: { ...row.usoMutuo, adere: umMap[row.digitadorId] || null },
  }));
};

/** Normaliza resumo admin (pipeline + campos opcionais A1). */
export const normalizeResumoAdmin = (data) => {
  const base = normalizeResumoLegacy(data);
  const equipeRaw = data?.equipe && typeof data.equipe === 'object' ? data.equipe : null;
  const porLenteRaw = Array.isArray(data?.porLente) ? data.porLente : [];

  return {
    ...base,
    equipe: equipeRaw
      ? {
          ...EMPTY_EQUIPE,
          ...equipeRaw,
          piorCarga: equipeRaw.piorCarga || null,
          adere: normalizeAdere(equipeRaw.adere),
        }
      : { ...EMPTY_EQUIPE },
    porLente: porLenteRaw.map((item) => ({
      ...EMPTY_POR_LENTE,
      ...item,
      adere: normalizeAdere(item.adere),
    })),
  };
};

/**
 * Body API por lente. Sempre regrava `tipoServicos` depois do legado
 * (o normalizer antigo injeta só MT/BT quando o array não entra).
 * MT/BT → `…e25` · uso mútuo → `…e27` · geral → os dois.
 */
export const normalizeFilterForLente = (filter, lenteId) => {
  const tipoServicos = getTipoServicosByLente(lenteId);
  const body = normalizeFilterForApiLegacy({
    ...filter,
    tipoServicos,
  });
  body.tipoServicos = tipoServicos;
  if (lenteId && lenteId !== LENTE_IDS.GERAL) {
    body.lenteId = lenteId;
  }
  return body;
};

export const getMetaDiaria = (lenteId) => META_DIARIA[lenteId] ?? null;

export const getUnidadeLabel = (lenteId) => (
  lenteId === LENTE_IDS.USO_MUTUO ? 'postes' : 'serviços'
);

export const getItemMedia = (item) => {
  if (item?.mediaDiaUtil != null) return Number(item.mediaDiaUtil);
  return null;
};

export const getItemPendentes = (item) => {
  if (item?.servicosPendentes != null) return Number(item.servicosPendentes);
  const total = item?.servicosTotal ?? item?.total ?? 0;
  const digitados = item?.servicosDigitados ?? 0;
  return Math.max(0, total - digitados);
};

/** Deriva métricas de equipe a partir dos charts quando A1 ainda não existe. */
export const deriveEquipeFromItems = (prodItems, cargaItems, lenteId) => {
  const meta = getMetaDiaria(lenteId);
  const items = prodItems?.length ? prodItems : [];
  const N = items.length;
  const medias = items.map(getItemMedia).filter((v) => v != null);
  const mediaDiaUtil = medias.length
    ? medias.reduce((a, b) => a + b, 0) / medias.length
    : null;
  const abaixoMetaCount = meta != null
    ? items.filter((item) => {
      const m = getItemMedia(item);
      return m != null && m < meta;
    }).length
    : null;
  const cargaSorted = [...(cargaItems || [])].sort(
    (a, b) => getItemPendentes(b) - getItemPendentes(a),
  );
  const pior = cargaSorted[0];
  const digitadoresComPendencia = (cargaItems || []).filter(
    (item) => getItemPendentes(item) > 0,
  ).length;
  const servicosPendentes = (cargaItems || []).reduce(
    (acc, item) => acc + getItemPendentes(item),
    0,
  );
  const nsirs = (cargaItems || []).reduce((acc, item) => acc + (item.nsirs ?? 0), 0);
  const servicosTotal = (cargaItems || []).reduce(
    (acc, item) => acc + (item.servicosTotal ?? item.total ?? 0),
    0,
  );
  const servicosDigitados = (cargaItems || []).reduce(
    (acc, item) => acc + (item.servicosDigitados ?? 0),
    0,
  );

  return {
    ...EMPTY_EQUIPE,
    digitadoresCount: N || null,
    mediaDiaUtil,
    abaixoMetaCount,
    metaDiaria: meta,
    lenteId,
    unidade: lenteId === LENTE_IDS.USO_MUTUO ? 'postes' : 'servicos',
    servicosPendentes,
    digitadoresComPendencia,
    piorCarga: pior
      ? {
          digitadorId: pior.digitadorId,
          nome: pior.digitadorNome,
          pendentes: getItemPendentes(pior),
        }
      : null,
    nsirs,
    servicosTotal,
    servicosDigitados,
  };
};

export const applyRankingSlice = ({
  prodItems = [],
  cargaItems = [],
  lenteId,
  recorte = RANKING_RECORTE.TOP,
  order = RANKING_ORDER.MEDIA_DESC,
  limit = TOP_N_DEFAULT,
}) => {
  const meta = getMetaDiaria(lenteId);
  const cargaById = new Map((cargaItems || []).map((item) => [item.digitadorId, item]));

  let rows = (prodItems || []).map((item) => {
    const carga = cargaById.get(item.digitadorId);
    const media = getItemMedia(item);
    const pendentes = carga ? getItemPendentes(carga) : 0;
    return {
      ...item,
      mediaDiaUtil: media,
      pendentes,
      abaixoMeta: meta != null && media != null && media < meta,
      servicosDigitados: carga?.servicosDigitados ?? 0,
      servicosPendentes: pendentes,
      servicosTotal: carga?.servicosTotal ?? item.total ?? 0,
      nsirs: carga?.nsirs ?? 0,
    };
  });

  if (recorte === RANKING_RECORTE.ABAIXO_META) {
    rows = rows.filter((row) => row.abaixoMeta);
  } else if (recorte === RANKING_RECORTE.MAIS_CARGA) {
    rows = [...rows].sort((a, b) => b.pendentes - a.pendentes).slice(0, limit);
    return rows;
  }

  if (order === RANKING_ORDER.MEDIA_ASC) {
    rows = [...rows].sort((a, b) => (a.mediaDiaUtil ?? 0) - (b.mediaDiaUtil ?? 0));
  } else if (order === RANKING_ORDER.PENDENTES_DESC) {
    rows = [...rows].sort((a, b) => b.pendentes - a.pendentes);
  } else {
    rows = [...rows].sort((a, b) => (b.mediaDiaUtil ?? 0) - (a.mediaDiaUtil ?? 0));
  }

  if (recorte === RANKING_RECORTE.BOTTOM) {
    rows = [...rows].reverse();
  }

  return rows.slice(0, limit);
};

/** Merge A2/A3 MT/BT + UM → linhas da tabela Geral (fallback A4). */
export const mergeEquipeRows = ({ mtbtProd, mtbtCarga, umProd, umCarga }) => {
  const map = new Map();

  const ensure = (id, nome) => {
    if (!map.has(id)) {
      map.set(id, {
        id,
        digitadorId: id,
        nome: nome || '—',
        mtbt: {
          nsirs: 0,
          servicosDigitados: 0,
          servicosTotal: 0,
          servicosPendentes: 0,
          mediaDiaUtil: null,
          abaixoMeta: false,
          porGerencia: [],
          adere: null,
        },
        usoMutuo: {
          nsirs: 0,
          servicosDigitados: 0,
          servicosTotal: 0,
          servicosPendentes: 0,
          mediaDiaUtil: null,
          abaixoMeta: false,
          porGerencia: [],
        },
      });
    }
    return map.get(id);
  };

  (mtbtProd || []).forEach((item) => {
    const row = ensure(item.digitadorId, item.digitadorNome);
    row.mtbt.mediaDiaUtil = getItemMedia(item);
    row.mtbt.abaixoMeta = row.mtbt.mediaDiaUtil != null
      && row.mtbt.mediaDiaUtil < META_DIARIA[LENTE_IDS.MT_BT];
  });
  (mtbtCarga || []).forEach((item) => {
    const row = ensure(item.digitadorId, item.digitadorNome);
    row.mtbt.nsirs = item.nsirs ?? 0;
    row.mtbt.servicosDigitados = item.servicosDigitados ?? 0;
    row.mtbt.servicosTotal = item.servicosTotal ?? 0;
    row.mtbt.servicosPendentes = getItemPendentes(item);
  });
  (umProd || []).forEach((item) => {
    const row = ensure(item.digitadorId, item.digitadorNome);
    row.usoMutuo.mediaDiaUtil = getItemMedia(item);
    row.usoMutuo.abaixoMeta = row.usoMutuo.mediaDiaUtil != null
      && row.usoMutuo.mediaDiaUtil < META_DIARIA[LENTE_IDS.USO_MUTUO];
  });
  (umCarga || []).forEach((item) => {
    const row = ensure(item.digitadorId, item.digitadorNome);
    row.usoMutuo.nsirs = item.nsirs ?? 0;
    row.usoMutuo.servicosDigitados = item.servicosDigitados ?? 0;
    row.usoMutuo.servicosTotal = item.servicosTotal ?? 0;
    row.usoMutuo.servicosPendentes = getItemPendentes(item);
  });

  return attachPorGerencia(
    Array.from(map.values()).sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR')),
    mtbtCarga,
    umCarga,
  );
};

const porGerenciaFromCarga = (items) => {
  const map = new Map();
  (items || []).forEach((item) => {
    if (!item?.digitadorId) return;
    map.set(item.digitadorId, item.porGerencia || []);
  });
  return map;
};

/** Anexa porGerencia **por lente**. Não soma MT/BT + uso mútuo na mesma célula. */
export const attachPorGerencia = (rows, mtbtCarga = [], umCarga = []) => {
  const mtbtMap = porGerenciaFromCarga(mtbtCarga);
  const umMap = porGerenciaFromCarga(umCarga);
  return (rows || []).map((row) => {
    const mtbtPg = row.mtbt?.porGerencia?.length
      ? row.mtbt.porGerencia
      : (mtbtMap.get(row.digitadorId) || []);
    const umPg = row.usoMutuo?.porGerencia?.length
      ? row.usoMutuo.porGerencia
      : (umMap.get(row.digitadorId) || []);
    const rowLevel = Array.isArray(row.porGerencia) ? row.porGerencia : [];
    return {
      ...row,
      mtbt: { ...row.mtbt, porGerencia: mtbtPg },
      usoMutuo: { ...row.usoMutuo, porGerencia: umPg },
      porGerencia: rowLevel,
      hasPorGerencia: mtbtPg.length > 0 || umPg.length > 0 || rowLevel.length > 0,
    };
  });
};

export const equipeHasPorGerencia = (rows) =>
  (rows || []).some((row) => row.hasPorGerencia);

export const getRowPendentesTotal = (row) =>
  (row?.mtbt?.servicosPendentes || 0) + (row?.usoMutuo?.servicosPendentes || 0);

export const getCargaGerenciaTotal = (porGerencia) =>
  (porGerencia || []).reduce((acc, g) => acc + (Number(g.pendentes) || 0), 0);

/** porGerencia da lente; se só existir bloco mesclado no row, devolve [] (não inventa split). */
export const getLentePorGerencia = (row, lenteId) => {
  if (lenteId === LENTE_IDS.MT_BT) return row?.mtbt?.porGerencia || [];
  if (lenteId === LENTE_IDS.USO_MUTUO) return row?.usoMutuo?.porGerencia || [];
  return [];
};

/** Digitador tem a lente se há volume, NSIR, pendência ou média (não mostrar zerado). */
export const lenteHasAtividade = (lente) => {
  if (!lente) return false;
  return (Number(lente.nsirs) || 0) > 0
    || (Number(lente.servicosTotal) || 0) > 0
    || (Number(lente.servicosDigitados) || 0) > 0
    || (Number(lente.servicosPendentes) || 0) > 0
    || lente.mediaDiaUtil != null;
};

export const normalizeByDigitadorResumo = (data) => {
  if (!data || typeof data !== 'object') {
    return { digitadoresCount: 0, rows: [] };
  }
  const rows = (data.rows || []).map((row) => ({
    id: row.digitadorId,
    digitadorId: row.digitadorId,
    nome: row.nome || '—',
    mtbt: {
      nsirs: 0,
      servicosDigitados: 0,
      servicosTotal: 0,
      servicosPendentes: 0,
      mediaDiaUtil: null,
      abaixoMeta: false,
      ...(row.mtbt || {}),
      porGerencia: Array.isArray(row.mtbt?.porGerencia) ? row.mtbt.porGerencia : [],
      adere: normalizeAdere(row.mtbt?.adere),
    },
    usoMutuo: {
      nsirs: 0,
      servicosDigitados: 0,
      servicosTotal: 0,
      servicosPendentes: 0,
      mediaDiaUtil: null,
      abaixoMeta: false,
      ...(row.usoMutuo || {}),
      porGerencia: Array.isArray(row.usoMutuo?.porGerencia)
        ? row.usoMutuo.porGerencia
        : [],
    },
    porGerencia: Array.isArray(row.porGerencia) ? row.porGerencia : [],
    hasPorGerencia: Boolean(
      (row.mtbt?.porGerencia || []).length
      || (row.usoMutuo?.porGerencia || []).length
      || (row.porGerencia || []).length,
    ),
  }));
  return {
    digitadoresCount: data.digitadoresCount ?? rows.length,
    rows,
  };
};

export const filterEquipeRows = (rows, { q = '', chip = EQUIPE_CHIP.TODOS } = {}) => {
  const query = q.trim().toLowerCase();
  return (rows || []).filter((row) => {
    if (query && !(row.nome || '').toLowerCase().includes(query)) return false;
    if (chip === EQUIPE_CHIP.ABAIXO_MT_BT) return row.mtbt?.abaixoMeta;
    if (chip === EQUIPE_CHIP.ABAIXO_UM) return row.usoMutuo?.abaixoMeta;
    if (chip === EQUIPE_CHIP.COM_PENDENTES) {
      return (row.mtbt?.servicosPendentes || 0) > 0
        || (row.usoMutuo?.servicosPendentes || 0) > 0;
    }
    return true;
  });
};

export const sortEquipeRows = (rows, sortId = EQUIPE_SORT.NOME) => {
  const list = [...(rows || [])];
  list.sort((a, b) => {
    if (sortId === EQUIPE_SORT.MEDIA) {
      return (b.mtbt?.mediaDiaUtil ?? -1) - (a.mtbt?.mediaDiaUtil ?? -1);
    }
    if (sortId === EQUIPE_SORT.PENDENTES) {
      return getRowPendentesTotal(b) - getRowPendentesTotal(a);
    }
    if (sortId === EQUIPE_SORT.NSIRS) {
      const na = (a.mtbt?.nsirs || 0) + (a.usoMutuo?.nsirs || 0);
      const nb = (b.mtbt?.nsirs || 0) + (b.usoMutuo?.nsirs || 0);
      return nb - na;
    }
    return (a.nome || '').localeCompare(b.nome || '', 'pt-BR');
  });
  return list;
};

export const digitadorDrillPath = (digitadorId) => `/v2/digitacao/digitador/${digitadorId}`;

export const openDigitadorDrill = ({ digitadorId, nome }) => {
  if (!digitadorId || typeof window === 'undefined') return;
  const params = new URLSearchParams();
  if (nome) params.set('nome', nome);
  const qs = params.toString();
  const path = `${digitadorDrillPath(digitadorId)}${qs ? `?${qs}` : ''}`;
  window.open(path, '_blank', 'noopener,noreferrer');
};

export const pushDigitadorDrill = (history, { digitadorId, nome, from = COMMAND_CENTER_PATH }) => {
  if (!history || !digitadorId) return;
  history.push({
    pathname: digitadorDrillPath(digitadorId),
    state: { nome, from },
  });
};

export const openNsirsCargaDrill = ({ malhaId, digitadorId }) => {
  if (!malhaId || typeof window === 'undefined') return;
  const params = new URLSearchParams({ malhaId });
  if (digitadorId) params.set('digitadorId', digitadorId);
  window.open(`/v2/nsirs?${params.toString()}`, '_blank', 'noopener,noreferrer');
};

export const readStoredLenteId = () => {
  try {
    const stored = sessionStorage.getItem(LENTE_SESSION_KEY);
    if (Object.values(LENTE_IDS).includes(stored)) return stored;
  } catch {
    // sessionStorage indisponível
  }
  return LENTE_IDS.GERAL;
};

export const persistLenteId = (lenteId) => {
  try {
    sessionStorage.setItem(LENTE_SESSION_KEY, lenteId);
  } catch {
    // sessionStorage indisponível
  }
};

export const TIPO_QUERY_PARAM = 'tipo';

export const parseLenteIdFromSearch = (search) => {
  const tipo = new URLSearchParams(search || '').get(TIPO_QUERY_PARAM);
  if (tipo === LENTE_IDS.MT_BT || tipo === LENTE_IDS.USO_MUTUO) return tipo;
  return LENTE_IDS.GERAL;
};

export const writeLenteIdToSearch = (search, lenteId) => {
  const next = new URLSearchParams(search || '');
  next.delete('p');
  next.delete('s');
  if (lenteId && lenteId !== LENTE_IDS.GERAL) {
    next.set(TIPO_QUERY_PARAM, lenteId);
  } else {
    next.delete(TIPO_QUERY_PARAM);
  }
  const qs = next.toString();
  return qs ? `?${qs}` : '';
};

export const readInitialLenteId = () => {
  if (typeof window === 'undefined') return LENTE_IDS.GERAL;
  const fromUrl = parseLenteIdFromSearch(window.location.search);
  if (fromUrl !== LENTE_IDS.GERAL) return fromUrl;
  return readStoredLenteId();
};

const addMetrics = (a, b) => ({
  nsirs: (a?.nsirs || 0) + (b?.nsirs || 0),
  servicos: (a?.servicos || 0) + (b?.servicos || 0),
  servicosTotal: (a?.servicosTotal || 0) + (b?.servicosTotal || 0),
  servicosDigitados: (a?.servicosDigitados || 0) + (b?.servicosDigitados || 0),
  servicosPendentes: (a?.servicosPendentes || 0) + (b?.servicosPendentes || 0),
  hasBreakdown: Boolean(a?.hasBreakdown || b?.hasBreakdown),
});

const mergeStatusMap = (left, right) => {
  const out = {};
  STATUS_ORDER.forEach((status) => {
    out[status] = addMetrics(getMetric(left, status), getMetric(right, status));
  });
  return out;
};

/** Soma pipeline MT/BT + uso mútuo para o KpiStrip da tab Geral. */
export const mergeResumoAdminPair = (mtbt, um) => {
  const left = mtbt || normalizeResumoAdmin(null);
  const right = um || normalizeResumoAdmin(null);
  const porLente = [
    ...(left.porLente || []).filter((item) => item.lenteId === LENTE_IDS.MT_BT),
    ...(right.porLente || []).filter((item) => item.lenteId === LENTE_IDS.USO_MUTUO),
  ];
  const equipeSrc = left.equipe?.diasUteisGlobais != null ? left.equipe : right.equipe;
  return {
    filtrado: mergeStatusMap(left.filtrado, right.filtrado),
    total: mergeStatusMap(left.total, right.total),
    equipe: equipeSrc || { ...EMPTY_EQUIPE },
    porLente,
  };
};

export const aggregatePendentesPorGerencia = (cargaItems) => {
  const map = new Map();
  GERENCIA_SIGLAS.forEach((sigla) => {
    map.set(sigla, {
      sigla,
      nome: sigla,
      gerenciaId: null,
      pendentes: 0,
    });
  });
  let hasAny = false;
  (cargaItems || []).forEach((item) => {
    (item.porGerencia || []).forEach((g) => {
      const sigla = g?.sigla;
      if (!sigla) return;
      hasAny = true;
      const prev = map.get(sigla) || {
        sigla,
        nome: g.nome || sigla,
        gerenciaId: g.gerenciaId || null,
        pendentes: 0,
      };
      prev.pendentes += Number(g.pendentes) || 0;
      if (!prev.gerenciaId && g.gerenciaId) prev.gerenciaId = g.gerenciaId;
      if (g.nome) prev.nome = g.nome;
      map.set(sigla, prev);
    });
  });
  if (!hasAny) return [];
  return GERENCIA_SIGLAS.map((sigla) => map.get(sigla)).filter(Boolean);
};

export const formatAtualizadoHa = (stamp, now = moment()) => {
  if (stamp == null) return null;
  const then = moment(stamp);
  const secs = now.diff(then, 'seconds');
  if (secs < 15) return 'Atualizado agora';
  const mins = now.diff(then, 'minutes');
  if (mins < 1) return 'Atualizado agora';
  if (mins === 1) return 'Atualizado há 1 min';
  if (mins < 60) return `Atualizado há ${mins} min`;
  const hours = now.diff(then, 'hours');
  if (hours === 1) return 'Atualizado há 1 h';
  if (hours < 24) return `Atualizado há ${hours} h`;
  return `Atualizado em ${then.format('DD/MM/YYYY HH:mm')}`;
};

export const formatAtualizadoExact = (stamp) => {
  if (stamp == null) return '';
  return moment(stamp).format('DD/MM/YYYY HH:mm');
};

/**
 * Body de `POST /reports/digitacao/daily` no command center.
 * Chaves singulares (contrato do export). Não injeta o id do admin logado.
 */
export const normalizeAdminExportForApi = (filter) => {
  if (!filter || typeof filter !== 'object') return {};
  const body = {};
  if (filter.inicio != null) body.inicio = filter.inicio;
  if (filter.fim != null) body.fim = filter.fim;
  if (filter.codigo) body.codigo = filter.codigo;
  body.dateTypes = Array.isArray(filter.dateTypes) && filter.dateTypes.length > 0
    ? filter.dateTypes
    : ['DATA_DIGITACAO'];

  const toArray = (v) => {
    if (Array.isArray(v)) return v.filter((item) => item != null && item !== '');
    if (v != null && v !== '') return [v];
    return [];
  };
  const digitadorId = toArray(filter.digitadorId);
  if (digitadorId.length > 0) body.digitadorId = digitadorId;

  const tipoServicos = toArray(filter.tipoServicos);
  if (tipoServicos.length > 0) body.tipoServicos = tipoServicos;

  const subTipoIds = toArray(filter.subTipoIds);
  if (subTipoIds.length > 0) body.subTipoIds = subTipoIds;

  const clienteIds = toArray(filter.clienteIds);
  if (clienteIds.length > 0) body.clienteIds = clienteIds;

  const statuses = toArray(filter.statuses);
  if (statuses.length > 0) body.statuses = statuses;

  if (filter.malhaId != null && filter.malhaId !== '') {
    body.malhaId = Array.isArray(filter.malhaId) ? filter.malhaId[0] : filter.malhaId;
  }
  if (filter.gerenciaId) body.gerenciaId = filter.gerenciaId;
  if (filter.poloId) body.poloId = filter.poloId;
  if (filter.subestacaoId) body.subestacaoId = filter.subestacaoId;
  if (filter.alimentadorId) body.alimentadorId = filter.alimentadorId;
  return body;
};

export const filterLenteLookupRows = (rows, chip = LENTE_LOOKUP_CHIP.TODOS) => {
  if (chip === LENTE_LOOKUP_CHIP.ABAIXO) {
    return (rows || []).filter((row) => row.abaixoMeta);
  }
  if (chip === LENTE_LOOKUP_CHIP.PENDENTES) {
    return (rows || []).filter((row) => (row.pendentes || 0) > 0);
  }
  return rows || [];
};

export const formatMedia = (value) => {
  if (value == null || Number.isNaN(Number(value))) return '—';
  return Number(value).toLocaleString('pt-BR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  });
};
